import React, { useState, useEffect } from "react";
import { Spinner, Accordion } from "react-bootstrap";
import "./convocatorias.css";
import { getJsonFromStorage } from "../../../utils/getJsonFromStorage";

function Convocatoria() {
  const [convocatoria, setConvocatoria] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const fetchConvocatoria = async () => {
      try {
        const jsonData = await getJsonFromStorage("convocatorias.json");
        if (jsonData && jsonData.length > 0) {
          setConvocatoria(jsonData);
        } else {
          setConvocatoria([]);
        }
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchConvocatoria();
  }, []);

  const getYearFromInicio = (inicio) => {
    if (!inicio) return null;
    const parts = inicio.split("-"); // dd-mm-yyyy
    if (parts.length === 3) {
      return parseInt(parts[2], 10);
    }
    return null;
  };

  const isOld = (item) => {
    const year = getYearFromInicio(item.inicio);
    return year && year < currentYear;
  };

  const sortByFecha = (list) =>
    list.slice().sort((a, b) => {
      const [da, ma, ya] = a.inicio.split("-");
      const [db, mb, yb] = b.inicio.split("-");
      const dateA = new Date(`${ya}-${ma}-${da}`);
      const dateB = new Date(`${yb}-${mb}-${db}`);
      return dateB - dateA;
    });

  const renderItem = (item, idx) => (
    <div
      className={`convocatoria-item ${item.disable ? "disabled" : ""}`}
      key={idx}
    >
      <div className="convocatoria-item-body">
        <div className="convocatoria-item-title">{item.titulo}</div>
        <div className="convocatoria-item-badges">
          <div className="convocatoria-item-badge">
            {item.comuna}, Región {item.region}
          </div>
          <div className="convocatoria-item-badge">Inicio: {item.inicio}</div>
          <div className="convocatoria-item-badge">{item.empresa}</div>
          <div className="convocatoria-item-badge">{item.otec}</div>
          {item.asociado && (
            <div className="convocatoria-item-badge">{item.asociado}</div>
          )}
        </div>
        <span>Requisitos:</span>
        <ul>
          {item.requisitos.map((req, i) => (
            <li key={i}>{req}</li>
          ))}
        </ul>
      </div>
      <a
        href={item.link}
        className="btn btn-outline-primary convocatoria-item-button"
        style={{
          pointerEvents: item.disable ? "none" : "auto",
          opacity: item.disable ? 0.5 : 1,
        }}
        disabled={item.disable}
      >
        {item.disable ? "Postulación Cerrada" : "Postular"}
      </a>
    </div>
  );

  if (loading) {
    return (
      <div className="banner-loading">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="banner-loading">
        <Spinner animation="border" variant="primary" />
        No fue posible cargar la información.
      </div>
    );
  }

  const newerItems = sortByFecha(convocatoria.filter((item) => !isOld(item)));
  const olderItems = sortByFecha(convocatoria.filter(isOld));

  return (
    <>
      <h5 className="convocatoria-title">Convocatorias {currentYear}</h5>
      <div className="convocatoria-alert">
        Si quieres ser informada 📲 cuando aparezcan nuevas convocatorias en tu
        zona 👩🏻‍💻, puedes inscribirte ✍️ en el siguiente link:
        <a
          href="https://redmaestra.azurewebsites.net/api/formularios/agregar_comunidades/"
          className="convocatoria-alert-button purplebut"
        >
          Inscribirme
        </a>
      </div>

      {newerItems.map((item, idx) => renderItem(item, idx))}

      {olderItems.length > 0 && (
        <Accordion className="convocatoria-accordion">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Convocatorias Pasadas</Accordion.Header>
            <Accordion.Body>
              {olderItems.map((item, idx) => renderItem(item, `old-${idx}`))}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}
    </>
  );
}

export default Convocatoria;
